import { render, staticRenderFns } from "./OrderTaskListItem.vue?vue&type=template&id=38c36899&scoped=true"
import script from "./OrderTaskListItem.vue?vue&type=script&lang=js"
export * from "./OrderTaskListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c36899",
  null
  
)

export default component.exports